/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetUserTimelineResponseItems,
    GetUserTimelineResponseItemsFromJSON,
    GetUserTimelineResponseItemsFromJSONTyped,
    GetUserTimelineResponseItemsToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetUserTimelineResponse
 */
export interface GetUserTimelineResponse {
    /**
     * 
     * @type {Array<GetUserTimelineResponseItems>}
     * @memberof GetUserTimelineResponse
     */
    items?: Array<GetUserTimelineResponseItems>;
}

export function GetUserTimelineResponseFromJSON(json: any): GetUserTimelineResponse {
    return GetUserTimelineResponseFromJSONTyped(json, false);
}

export function GetUserTimelineResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserTimelineResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : ((json['items'] as Array<any>).map(GetUserTimelineResponseItemsFromJSON)),
    };
}

export function GetUserTimelineResponseToJSON(value?: GetUserTimelineResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : ((value.items as Array<any>).map(GetUserTimelineResponseItemsToJSON)),
    };
}


